<template>
  <div class="Masonry">
    <slot />
  </div>
</template>

<script>
import { flatten, pipe, splitEvery, transpose } from 'rambda'

export default {
}

export const sortMasonry = (columns, items) => pipe(
  splitEvery(columns),
  transpose,
  flatten,
)(items)
</script>

<style lang="scss">
.Masonry {
  column-count: 4;
  column-gap: $u;
}
</style>
